import { legalLinks } from './constants'

export const getLegalLinks = language => {
  if (!legalLinks[language]) return legalLinks.en

  return legalLinks[language]
}
